import { render, staticRenderFns } from "./top.vue?vue&type=template&id=3fbd1668&scoped=true"
import script from "./top.vue?vue&type=script&lang=ts"
export * from "./top.vue?vue&type=script&lang=ts"
import style0 from "./top.vue?vue&type=style&index=0&id=3fbd1668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd1668",
  null
  
)

export default component.exports